import {useInfiniteQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {useState} from 'react';
import * as ProviderMappingsService from '../services/ProviderMappingsService';

export const useProviderMappings = (productId?: string, customerId?: string, priceId?: string) => {
    const queryClient = useQueryClient();
    const [keyword, setKeyword] = useState('');
    const [limit] = useState(10);
    
    const sort = { column: 'created', direction: 'desc' as const };
    
    // Build filter based on context
    const filter: Record<string, string> = {};
    if (productId) {
        filter.entityType = 'Product';
        filter.localEntityId = productId;
    } else if (customerId) {
        filter.entityType = 'Customer';
        filter.localEntityId = customerId;
    } else if (priceId) {
        filter.entityType = 'Price';
        filter.localEntityId = priceId;
    }
    
    console.log('useProviderMappings params:', { productId, customerId, priceId });
    console.log('useProviderMappings filter:', filter);
    
    const providerMappingsQuery = useInfiniteQuery({
        queryKey: ['provider-mappings', productId, customerId, priceId, keyword, limit, sort.column, sort.direction],
        queryFn: ({ pageParam }) => ProviderMappingsService.fetchRecords({ 
            limit, 
            sort, 
            nextToken: pageParam,
            filter: Object.keys(filter).length > 0 ? filter : undefined
        }),
        getNextPageParam: (lastPage) => {
            if (!lastPage || !lastPage.nextToken) return undefined;
            return lastPage.nextToken;
        },
        initialPageParam: null as string | null
    });

    const deleteMutation = useMutation({
        mutationFn: async (ids: string[]) => {
            const promises = ids.map(id => ProviderMappingsService.deleteRecord(id));
            return Promise.all(promises);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['provider-mappings'] });
        }
    });

    const allItems = providerMappingsQuery.data?.pages?.flatMap(page => page?.items || []) || [];

    const deleteRecords = (ids?: string[]) => {
        if (ids && ids.length > 0) {
            deleteMutation.mutate(ids);
        }
    };

    return {
        items: allItems,
        loading: providerMappingsQuery.isLoading,
        nextToken: providerMappingsQuery.hasNextPage ? 'has-more' : null,
        fetchRecords: () => {
            if (providerMappingsQuery.hasNextPage) {
                providerMappingsQuery.fetchNextPage();
            }
        },
        deleteRecords,
        handleFilterByKeyword: setKeyword
    };
};